import React, { useState } from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import UseScrollReveal from '../Common/UseScrollReveal ';

const AwardWining = () => {
    UseScrollReveal();
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();

        // Calculate relative position (-50 to 50 range)
        const x = ((clientX - left) / width - 2) * 20; // Text movement
        const y = ((clientY - top) / height - 1) * 20;

        const bgX = ((clientX - left) / width - 5) * 30; // Background movement
        const bgY = ((clientY - top) / height - 0.5) * 30;

        setPosition({ x, y, bgX, bgY });
    };
    return (
        <>
            {/* <section className='award-wining-wrap d-flex align-items-center mouse-container'
                onMouseMove={handleMouseMove}
                style={{
                    backgroundPosition: `${50 + position.bgX}% ${50 + position.bgY}%`,
                }}
            >
                <div className='w-100 text-center mouse-text'
                    style={{
                        transform: `translate(${position.x}px, ${position.y}px)`,
                    }}
                >
                    <div className='main-title mb-4'>
                        <span>AWARD WINNING SERVICE DEPARTMENT</span> <br />
                        NOW OFFERING PICKUP & DELIVERY
                    </div>
                    <button type='button' className='theme-btn text-uppercase'>Get Started</button>
                </div>
            </section> */}
            <section className='award-wining-wrap'>
                <div className="mouse-container" onMouseMove={handleMouseMove}>
                    {/* Background Move Effect */}
                    <motion.div
                        className="mouse-background"
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    {/* Text Move Effect */}
                    {/* <motion.span
                        className="mouse-text"
                        animate={{
                            x: position.x,
                            y: position.y,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    >
                        Move Me
                    </motion.span> */}
                    <div className='w-100 text-center mouse-text'
                        // animate={{
                        //     x: position.x,
                        //     y: position.y,
                        // }}
                        // transition={{ type: "tween", stiffness: 50 }}
                    >
                        <h2 className='main-title mb-4 reveal wow fadeIn'>
                            <span>AWARD WINNING SERVICE DEPARTMENT</span> <br />
                            NOW OFFERING PICKUP & DELIVERY
                        </h2>
                        <Link to="/service" className='theme-btn text-uppercase d-inline-block reveal wow fadeIn'>Get Started</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AwardWining